import baseRoute from '../baseRoute';

export default `${baseRoute}/jobMaterialCost` as const;
